  import React, { Fragment } from 'react';

  // Components
  import Refund_Policy from '../policies/Refund_Policy';
  
  const Refund = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Refund Policy
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Learn about our money-back guarantee and refund process.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <Refund_Policy isMobile={isMobile} />
            </div>
        </Fragment>
    );
  }
  
  export default Refund;
  